import { Modal } from "antd";
import React, { useContext } from "react";
import { AuthContext } from "./../index";

const ModalSelect = (props) => {
  const { ArrPackage, SetDataIsu } = useContext(AuthContext);

  return (
    <div style={{ fontSize: 14 }}>
      <Modal
        className="custom-modal-antd"
        style={{
          maxWidth: "100%",
          margin: 0,
          verticalAlign: "bottom",
          padding: 0,
          maxHeight: "90%",
        }}
        centered={true}
        footer={false}
        closable={false}
        open={props.isModalVisible}
        onCancel={props.handleCancel}
        maskStyle={{ backgroundColor: "rgba(0,0,0, 0.8)" }}
      >
        <div
          style={{
            borderBottom: "2px solid #828EE1",
            padding: "5px 10px 10px 10px",
            fontWeight: 500,
            fontSize: 16,
          }}
        >
          Chọn gói bảo hiểm
        </div>
        {(ArrPackage || []).map((data, i) => (
          <div
            onClick={() => {
              props.handleCancel();
              SetDataIsu({ package: data.id });
            }}
            key={data.id}
            style={{
              borderBottom: "1px solid #D9D9D9",
              padding: "14px",
              fontWeight: 400,
              fontSize: 14,
            }}
          >
            {data.title}
          </div>
        ))}
      </Modal>
    </div>
  );
};

export default ModalSelect;
